import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DevicesService} from '../../../../services/devices.service';
import {DeviceMeasurement} from '../../../../model/device-measurement';
import {IntegrationModule} from '../../../../model/integration-module';
import {
  defaultMeasurementTypeSensor
} from '../../../devices/devices-details/device-commands/industrial-gateway-commands/industrial-gateway-commands.component';

@Component({
  selector: 'app-synoptics-industrial-gateway-command-form',
  templateUrl: './synoptics-industrial-gateway.component.html',
  styleUrls: ['./synoptics-industrial-gateway.component.scss']
})
export class SynopticsIndustrialGatewayComponent implements OnInit {
  @Input() set mode(mode: 'form' | 'sendCommand') {
    this._mode = mode;
    this.checkValidity();
  }

  @Input() sensorValue: number;
  @Output() sensorValueChange: EventEmitter<number>;

  @Input() sensorName: string;
  @Output() sensorNameChange: EventEmitter<string>;

  @Input() deviceGateway: string;
  @Output() deviceGatewayChange: EventEmitter<string>;

  @Input() measurements: DeviceMeasurement[];
  @Input() deviceUuid: string;

  @Output() validFormChange: EventEmitter<boolean>;

  public loaded: boolean;

  public _mode: 'form' | 'sendCommand';

  constructor(private devicesService: DevicesService) {
    this.sensorValueChange = new EventEmitter<number>();
    this.sensorNameChange = new EventEmitter<string>();
    this.deviceGatewayChange = new EventEmitter<string>();
    this.validFormChange = new EventEmitter<boolean>();
  }

  ngOnInit(): void {
    this.loadUndefinedData();
  }

  loadUndefinedData(): void {
    this.loaded = false;
    const promises: Promise<any>[] = [];

    if (!this.deviceGateway) {
      const promiseGateway: Promise<void> = this.devicesService.getDeviceIntegrationModules(this.deviceUuid)
        .toPromise()
        .then(response => {
          const additionalInfo: any = JSON.parse(response.integrationModules.find((im: IntegrationModule): boolean => im.encoder.name === 'industrial-gateway-v1').additionalInfo);
          const subString: string = additionalInfo.entryPoint.split('.devices.')[0];
          const lastIndex: number = subString.lastIndexOf('.');
          this.updateGateway(subString.slice(lastIndex + 1));
        });
      promises.push(promiseGateway);
    }

    if (!this.measurements) {
      const promiseMeasurements: Promise<void> = this.devicesService
        .getDeviceMeasurementsOfDeviceFilteredByMeasurementTypeSensor(this.deviceUuid, defaultMeasurementTypeSensor)
        .then((response: DeviceMeasurement[]) => {
          this.measurements = response;
        });
      promises.push(promiseMeasurements);
    }

    if (!this.sensorValue) {
      this.updateSensorValue(0);
    }

    Promise.all(promises).then((): void => {
      this.loaded = true;
    });
  }

  updateSensorName(value: string): void {
    this.sensorName = value;
    this.sensorNameChange.emit(value);
    this.checkValidity();
  }

  updateSensorValue(value: number): void {
    this.sensorValue = value;
    this.sensorValueChange.emit(value);
    this.checkValidity();
  }

  updateGateway(value: string): void {
    this.deviceGateway = value;
    this.deviceGatewayChange.emit(value);
    this.checkValidity();
  }

  checkValidity(): void {
    if (this.mode === 'form') {
      this.validFormChange.emit(true);
    } else {
      const isValid: boolean = this.sensorName !== undefined && this.sensorName !== null && this.deviceGateway !== undefined && this.deviceGateway !== null;
      this.validFormChange.emit(isValid);
    }
  }
}
